import {tokens} from '@pleo-io/telescope'
import styled from 'styled-components'

export const Wrapper = styled.div`
    display: inline-grid;
    grid-auto-flow: column;
    justify-content: start;
    gap: ${tokens.spacing4};

    img {
        width: 20px;
    }
`
